module.exports = __webpack_public_path__ + "img/sec4_box1.b7b94401.png";